import { render, staticRenderFns } from "./ConfigurarCurso.vue?vue&type=template&id=92255bfa&scoped=true&"
import script from "./ConfigurarCurso.vue?vue&type=script&lang=js&"
export * from "./ConfigurarCurso.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarCurso.vue?vue&type=style&index=0&id=92255bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92255bfa",
  null
  
)

export default component.exports